import React, {useEffect, useState} from "react";
import useIsMounted from "../../../../hooks/use-is-mounted";
import Api from "../../../../../core/services/api/api";
import IconButton from "../../../base/button/icon_button";
import {SvgIcon} from "@mui/material";
import {ReactComponent as RemoveIcon} from "../../../../../assets/images/remove.svg";
import BypassOrderDialog from "../../../dialogs/bypass-order";
import DateUtils from "../../../../../core/services/date-utils";


const OrderBypassInfoCard = ({
                                 loading,
                                 removable = false,
                                 orderId,
                                 openBypassDialog,
                                 setOpenBypassDialog,
                                 orderNo,
                                 getOrderInformation,
                                 customer,
                             }) => {
    const [loadingBypass, setLoadingBypass] = useState(false);
    const [removingBypass, setRemovingBypass] = useState(false);
    const [bypassInfo, setBypassInfo] = useState(null);
    const isMounted = useIsMounted();

    /**
     * With each change in quoteId of the params:
     * - fetches the current orders' bypass information from the server.
     */
    useEffect(() => {
        if (!orderId)
            return;
        const parsedOrderId = Number(orderId)
        if (Number.isNaN(parsedOrderId))
            return;
        getOrderBypassInformation(parsedOrderId).then();
    }, [orderId])

    /**
     * Fetches the current orders' bypass information from the server.
     * @param {number} orderId
     */
    const getOrderBypassInformation = async (orderId) => {
        setLoadingBypass(true);
        const response = await Api.getQuoteBypassInformation(orderId);
        if (!isMounted())
            return;
        setLoadingBypass(false);
        if (response?.resultFlag) {
            setBypassInfo(response.data);
        }
    }

    /**
     * Removes the bypass record information from the current order.
     *
     * * if the result is successful, fetches the order again since the payment info can not be determined by
     * current info.
     * @return {Promise<void>}
     */
    const removeBypassFromOrder = async () => {
        setRemovingBypass(true);
        const response = await Api.removeQuoteBypass(bypassInfo?.id);
        if (!isMounted()) return;
        setRemovingBypass(false);
        if (response?.resultFlag) {
            setBypassInfo(null);
            getOrderInformation();
        }
    }

    /**
     * Saves the given bypass info in the state to render appropriate information in the ui and fetches the order
     * information again.
     * @param {any} bypassInfo
     */
    const onBypassSubmitted = (bypassInfo) => {
        setBypassInfo(bypassInfo);
        getOrderInformation();
    }

    /**
     * Shows the removal confirmation dialog to the user before removing the bypass information
     */
    const getRemoveBypassConfirmation = () => {
        window.partner?.openConfirmationDialog(
            <div className={'p-3'}>
                <p className={'text-sm text-color-2'}>
                    Are you sure that you want to remove the bypass record from the selected order?
                </p>
            </div>,
            {
                maxWidth: 'sm'
            },
            (confirmed) => confirmed && removeBypassFromOrder(),
            "Confirm",
            "Cancel"
        );
    }

    return (
        <>
            {
                loadingBypass &&
                <div className={'loading cart-item mb-2'}>
                    <div/>
                </div>
            }
            {
                !loadingBypass && !!bypassInfo &&
                <div className={'order-bypass-card'}>
                    {
                        removable &&
                        <IconButton
                            onPressed={() => getRemoveBypassConfirmation()}
                            disabled={loading || removingBypass || loadingBypass}
                            color={'paper.error'}
                            className={'mr-2'}
                        >
                            <SvgIcon component={RemoveIcon} className='icon normal'/>
                        </IconButton>
                    }
                    <p>
                        Submitted ByPass
                        by<span>{bypassInfo.operatorName ?? ''} on {DateUtils.serverToLocal(bypassInfo?.submitDateTime).format(DateUtils.dateTimeFormat)}</span>
                        because of <span>{bypassInfo?.reason ?? ''}</span>
                    </p>
                </div>
            }
            <BypassOrderDialog
                open={openBypassDialog ?? false}
                setOpen={setOpenBypassDialog}
                onBypassSuccess={onBypassSubmitted}
                customer={customer}
                orderNo={orderNo}
                orderId={orderId}
            />
        </>
    );
}

export default OrderBypassInfoCard;
